module.exports = __webpack_public_path__ + "img/cz.1ef21014.svg";